<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ClindIcon from './ClindIcon.vue';

const props = defineProps({
  size: {
    type: String,
    default: 'default',
    validator: value => ['sm', 'default', 'lg'].includes(value),
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);

const { t } = useI18n();

const sizeValue = computed(() => {
  const sizes = {
    sm: 64,
    default: 82,
    lg: 96,
  };
  return sizes[props.size];
});

const computedAriaLabel = computed(() => {
  return props.ariaLabel || t('COPILOT.OPEN_LAUNCHER');
});

const handleClick = () => {
  emit('click');
};
</script>

<template>
  <button
    type="button"
    class="cursor-pointer hover:scale-110 transition-transform duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-n-lime-9 focus-visible:ring-offset-2 rounded-full"
    :aria-label="computedAriaLabel"
    @click="handleClick"
  >
    <ClindIcon :width="sizeValue" :height="sizeValue" />
  </button>
</template>
